module.exports = __webpack_public_path__ + "static/media/thumbnail-playback@2x.2494273e.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/GymTvThumbnails/thumbnail-playback@2x.png
// module id = 1084
// module chunks = 2